import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const authHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
});

const getCategories = () =>
  axios
    .get(`${API_URL}/api/documents/categories`, authHeaders())
    .then((r) => r.data);

const createCategory = (data) =>
  axios
    .post(`${API_URL}/api/documents/categories`, data, authHeaders())
    .then((r) => r.data);

const updateCategory = (id, data) =>
  axios
    .put(`${API_URL}/api/documents/categories/${id}`, data, authHeaders())
    .then((r) => r.data);

const reorderCategories = (orders) =>
  axios
    .patch(`${API_URL}/api/documents/categories/reorder`, { orders }, authHeaders())
    .then((r) => r.data);

const deleteCategory = (id) =>
  axios
    .delete(`${API_URL}/api/documents/categories/${id}`, authHeaders())
    .then((r) => r.data);

const documentCategoryService = {
  getCategories,
  createCategory,
  updateCategory,
  reorderCategories,
  deleteCategory,
};

export default documentCategoryService;
